import type { EffectCallback } from "react"
import { useEffect, useRef } from "react"
import { createTheme } from "@mui/material";

export const UNAUTHORIZED = 401;
export const API_URL_START = 'api/v0'
export const FLAG_USE_NEW_WORKFLOW = process.env.FLAG_USE_NEW_WORKFLOW;


const xSifterBaseTheme = {
    palette: {
        primary: {
            main: "#5433d9",
            light: "#7353df",
            dark: "#1521c3",
            contrastText: "#fff",
        },
        secondary: {
            main: "#155dc3",
            light: "#1481e9",
            dark: "#123fa4",
            contrastText: "#fff",
        },
    }
};

export const xSifterTheme = createTheme(xSifterBaseTheme)

export const xSifterQueryBuilderTheme = createTheme({
    typography: {
        button: {
            fontSize: "14px",
        }
    },
    ...xSifterBaseTheme,
});


export function capitalizeFirstLetter(input: string): string {
    return input.charAt(0).toUpperCase() + input.slice(1);
}

export function debounceUseEffectCallback(callback: EffectCallback) {
    const initialized = useRef(false);

    useEffect(() => {
        if (!initialized.current) {
            initialized.current = true;
            callback();
        }
    }, [initialized]);
}

export function flagUseNewWorkflow(): boolean {
    if (FLAG_USE_NEW_WORKFLOW && FLAG_USE_NEW_WORKFLOW === 'true')
        return true;
    return false;
}
